// extracted by mini-css-extract-plugin
module.exports = {"content":"ChatPopup_content__1AhDf","header":"ChatPopup_header__e9QIn","body":"ChatPopup_body__wpWJD"};